import { getDay, getDate, getMonth, getYear } from "date-fns";

// Helper function to get the nth occurrence of a weekday in a month
export const getNthWeekday = (year, month, weekday, n) => {
    const firstDay = new Date(year, month, 1);
    const firstWeekday = getDay(firstDay);
    const offset = (weekday - firstWeekday + 7) % 7;
    const date = 1 + offset + (n - 1) * 7;
    return new Date(year, month, date);
};

// Check if a date is a holiday and return the holiday name
export const isHoliday = (date) => {
    const year = getYear(date);
    const month = getMonth(date);
    const day = getDate(date);

    // Fixed date holidays
    // New Year's Day (January 1)
    if (month === 0 && day === 1) return "New Year's Day";

    // Independence Day (July 4)
    if (month === 6 && day === 4) return "Independence Day";

    // Christmas (December 25)
    if (month === 11 && day === 25) return "Christmas";

    // New Year's Eve (December 31)
    if (month === 11 && day === 31) return "New Year's Eve";

    // Variable date holidays
    // Martin Luther King Jr. Day (3rd Monday of January)
    const mlkDay = getNthWeekday(year, 0, 1, 3);
    if (month === 0 && day === getDate(mlkDay)) return "Martin Luther King Jr. Day";

    // Presidents' Day (3rd Monday of February)
    const presidentsDay = getNthWeekday(year, 1, 1, 3);
    if (month === 1 && day === getDate(presidentsDay)) return "Presidents' Day";

    // Memorial Day (Last Monday of May)
    const lastDayOfMay = new Date(year, 5, 0); // Last day of May
    let lastMonday = lastDayOfMay.getDate();
    while (getDay(new Date(year, 4, lastMonday)) !== 1) {
        lastMonday--;
    }
    if (month === 4 && day === lastMonday) return "Memorial Day";

    // Labor Day (1st Monday of September)
    const laborDay = getNthWeekday(year, 8, 1, 1);
    if (month === 8 && day === getDate(laborDay)) return "Labor Day";

    // Columbus Day (2nd Monday of October)
    const columbusDay = getNthWeekday(year, 9, 1, 2);
    if (month === 9 && day === getDate(columbusDay)) return "Columbus Day";

    // Veterans Day (November 11)
    if (month === 10 && day === 11) return "Veterans Day";

    // Thanksgiving (4th Thursday of November)
    const thanksgiving = getNthWeekday(year, 10, 4, 4);
    if (month === 10 && day === getDate(thanksgiving)) return "Thanksgiving";

    return null;
};

